import styled from 'styled-components';
import './theme';
import { typographyMixin } from './typographyMixin';
import { TypographyAttrProps, TypographyProps } from './types';

/** `Typography` is responsible for styling the text according to the designs */
export const Typography = styled.div.attrs((props: TypographyAttrProps) => ({ 'data-test': props['data-test'] ?? 'typography' }))<TypographyProps>`
  ${typographyMixin};
`;

Typography.defaultProps = {
  size: 'sm',
  type: 'regular',
};
